import React, { useContext } from 'react';
import { withRouter, Link } from 'react-router-dom';
import styles from './Oglas.module.css';
import { BASE_URL_PRILOG_DOWNLOAD } from '../util/constants';
import { parseTimestamp } from '../util/TimestampParser';
import { ThemeContext } from '../contexts/ThemeContext';
import { ReactComponent as FileAttachment } from '../assets/file-attachment.svg';

const Oglas = (props) => {
  const { dark } = useContext(ThemeContext);

  return (
    <div className={styles.oglas}>
      <div className={styles.oglasHeader}>
        <Link to={'/oglasi/godina/' + props.match.params.id + '/oglas/' + props.id}>
          <div className={dark ? styles.oglasHeadingDark : styles.oglasHeadingLight}>
            {props.naslov}{props.uvod != null && props.uvod.trim() !== "" ? " - " + props.uvod : ""}
          </div>
        </Link>
        <div className={styles.oglasTimestamp}>{parseTimestamp(props.vrijemeKreiranja).join(' ')}</div>
      </div>
      <div className={styles.oglasBody}>{props.sadrzaj.trim()}</div>
      <div className={styles.oglasAttachments}>
        {props.oglasPrilozi.map(prilog => {
          return (
            <div
              key={prilog.id}
              className={dark ? styles.oglasPrilogDark : styles.oglasPrilogLight}>
                <a target='_blank' rel="noopener noreferrer" href={BASE_URL_PRILOG_DOWNLOAD + props.id + '/download'}>
                <FileAttachment className={dark ? styles.fileAttachmentDark : styles.fileAttachmentLight} />
                {prilog.originalniNaziv}</a></div>
          );
        })}
      </div>
      <div className={dark ? styles.oglasSignatureDark : styles.oglasSignatureLight }>{props.potpis}</div>
    </div>
  );
}

export default withRouter(Oglas);